/**
 * Фоны баннера на главной (сгенерированы для Qaraqalpaq Market, без текста). Две ширины: 720 px — для обычных
 * телефонов, 1200 px — для плотных экранов и компьютера. Каждый ~15–55 КБ в WebP; за визит грузится один.
 */
import ustyurtSunset720 from './ustyurt-sunset-720.webp';
import ustyurtSunset1200 from './ustyurt-sunset-1200.webp';
import nukusMonument720 from './nukus-monument-720.webp';
import nukusMonument1200 from './nukus-monument-1200.webp';
import aralSalt720 from './aral-salt-720.webp';
import aralSalt1200 from './aral-salt-1200.webp';
import dutar720 from './dutar-720.webp';
import dutar1200 from './dutar-1200.webp';
import road720 from './road-720.webp';
import road1200 from './road-1200.webp';
import tvTower720 from './tv-tower-720.webp';
import tvTower1200 from './tv-tower-1200.webp';
import rider720 from './rider-720.webp';
import rider1200 from './rider-1200.webp';
import bazaar720 from './bazaar-720.webp';
import bazaar1200 from './bazaar-1200.webp';
import ustyurtCliff720 from './ustyurt-cliff-720.webp';
import ustyurtCliff1200 from './ustyurt-cliff-1200.webp';
import sofa720 from './sofa-720.webp';
import sofa1200 from './sofa-1200.webp';
import lake720 from './lake-720.webp';
import lake1200 from './lake-1200.webp';

export interface HeroScene { id: string; small: string; large: string; /** Где главный объект — туда не сдвигаем кадр. */ position?: string }

export const HERO_SCENES: HeroScene[] = [
  { id: 'ustyurt-sunset', small: ustyurtSunset720, large: ustyurtSunset1200 },
  { id: 'nukus-monument', small: nukusMonument720, large: nukusMonument1200, position: 'right 40%' },
  { id: 'aral-salt', small: aralSalt720, large: aralSalt1200 },
  { id: 'dutar', small: dutar720, large: dutar1200, position: 'right center' },
  { id: 'road', small: road720, large: road1200 },
  { id: 'tv-tower', small: tvTower720, large: tvTower1200, position: 'right center' },
  { id: 'rider', small: rider720, large: rider1200, position: 'center 35%' },
  { id: 'bazaar', small: bazaar720, large: bazaar1200 },
  { id: 'ustyurt-cliff', small: ustyurtCliff720, large: ustyurtCliff1200 },
  { id: 'sofa', small: sofa720, large: sofa1200 },
  { id: 'lake', small: lake720, large: lake1200 },
];
